import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Calls the risk analyze API using the shared axios instance.
 *
 * Note:
 * Authorization, user_id, txn_id and source headers are automatically
 * attached by the axios request interceptor in axiosConfig.
 *
 * @param {Object} params
 * @param {string} params.query - Entity details query text
 * @param {string} [params.applicationNo] - Application number (financial flow only; saved in DB only, not sent to python API).
 *                                          Compulsory when loginType is "Logged-In", optional otherwise.
 * @param {string} [params.loginType] - "Pre-Login" | "Logged-In"
 * @param {string} params.type - Feature type e.g. "financial" | "investment"
 */
export async function analyzeRiskAPI({
  query,
  applicationNo,
  loginType,
  type,
}) {
  setBaseURL(api, REACT_APP_BASE_URL);

  const response = await api.post(
    "/api/v1.0/risk/analyze",
    {
      query,
      applicationNo,
      loginType,
      type,
    }
  );

  return response.data;
}